var render = function render(){var _vm=this,_c=_vm._self._c;return (['KoLPopularCaseCategory','KoLPopularCaseCategoryBoard'].includes(_vm.$route.name))?_c('router-view'):_c('PageHeaderLayout',[_c('div',{staticClass:"main-page-content"},[_c('ApeMenu',{attrs:{"menus":_vm.menus}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }